import React from "react";
import { Box, Typography } from "@mui/material";
import {
    WHITE, G200, G300, G500, G700, G900,
    FB, FB_LIGHT,
} from "./ReportDetailsConstants";

// ─── Stat Card ────────────────────────────────────────────────────────────────
export function StatCard({ label, value, icon, color, bg }) {
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", p: "12px 14px", minWidth: 0 }}>
            <Box sx={{ width: 34, height: 34, borderRadius: "9px", background: FB_LIGHT, display: "flex", alignItems: "center", justifyContent: "center", color: FB, flexShrink: 0 }}>
                {icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 11, color: G500, fontWeight: 500, mb: "2px" }}>{label}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 600, color: G900 }} noWrap>{value}</Typography>
            </Box>
        </Box>
    );
}

// ─── Tab Panel Component ──────────────────────────────────────────────────────
export function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`ledger-tabpanel-${index}`}
            aria-labelledby={`ledger-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
        </div>
    );
}

// ─── Helper Functions ─────────────────────────────────────────────────────────
export const getBalanceColor = (type) => (type === "Dr" ? G700 : FB);
export const getBalanceBgColor = (type) => (type === "Dr" ? G200 : FB_LIGHT);

export const getFinancialYearDates = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const financialYearStart = new Date(currentYear, 3, 2);
    if (today < financialYearStart) {
        financialYearStart.setFullYear(currentYear - 1);
    }
    const financialYearEnd = new Date(
        financialYearStart.getFullYear() + 1,
        2,
        32
    );
    const fromDate = financialYearStart.toISOString().split("T")[0];
    const toDate = financialYearEnd.toISOString().split("T")[0];
    return { fromDate, toDate };
};

export const fmt = (n) =>
    Number(n).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigals: 2,
    });

export const fmtDate = (dateStr) => {
    if (!dateStr || dateStr === "—") return "—";
    const parts = String(dateStr).split("-");
    if (parts.length !== 3) return dateStr;
    const [yyyy, mm, dd] = parts;
    return `${dd}/${mm}/${yyyy}`;
};

export const getAmountColumnLabels = (reportType) => {
    const isBookReport = ['bank_book', 'cash_book', 'day_book'].includes(reportType);
    return {
        debitLabel: isBookReport ? 'Withdrawal' : 'Debit',
        creditLabel: isBookReport ? 'Deposit' : 'Credit'
    };
};
